<template >
    <div class="tabs-stocks panel panel-default" v-if="salons">
        <form class="form-stock" role="form" :action="`/stocks/${salon_id}`" method="POST">
            <div class="stocks-head">
                <div class="form-group">
                    <h2 v-if="role_supervisor == 0">Выберите автосалон</h2>
                    <h3>Название автосалона </h3>
                    <select :disabled="role_supervisor != 0 ? true : false" class="salon_id form-control" name="salon_id" v-model="salon_id" v-on:change="salonCheck" >
                        <option disabled value="">Выберите салон</option>
                        <option v-for="salon in salons" :value="`${salon.id}`" :selected="salon.id==role_supervisor ? true : false">{{salon.name}}</option>
                    </select>
                </div>
            </div>


            <ul class="nav nav-tabs">
                <li :class="{active: activated == 0}">
                    <a @click="activated = 0; textarea = 0">
                        При запуске
                    </a>
                </li>
                <li :class="{active: activated == 1}">
                    <a @click="activated = 1; textarea = 1">
                        После анкеты
                    </a>
                </li>
            </ul>
            <input name="_method" value="PUT" type="hidden">
            <input name="_token" :value="`${csrf_token}`" type="hidden">
            <div class="panel panel-default" activated="0" v-show="activated == 0">

                <textarea :class="{active: textarea == 0}" name="before" v-model="before">{{before}}</textarea>
                <div>*Не более 1000 символов</div>
                <button type="submit" class="btn btn-primary btn-sm">Сохранить</button>
            </div>
            <div class="panel panel-default" activated="1" v-show="activated == 1">
                <textarea :class="{active: textarea == 1}" name="after" v-model="after">{{after}}</textarea>
                <div>*Не более 1000 символов</div>
                <button type="submit" class="btn btn-primary btn-sm">Сохранить</button>
            </div>
        </form>
    </div>
    <h3 v-else>Загрузка салонов ...</h3>
</template>

<script>
    export default {
        data() {
            return {
                limit: 0,
                activated: 1,
                textarea: 1,
                salon_id: this.session_salon_id,
                before: '',
                after: '',
            }
        },
        props: ['csrf_token', 'role_supervisor', 'session_salon_id'],
        asyncComputed: {
            salons() {
                return axios
                    .get('/api/salons', {
                        params: {
                            q: '',
                            limit: this.limit
                        }
                    })
                    .then(({data}) => {
                        this.salonCheck()
                        return data.data
                    })
            },
        },
        methods: {
            salonCheck: function (event) {
                this.before = 'Загрузка ...'
                this.after = 'Загрузка ...'
                return axios
                    .get('/api/stocks/' + this.salon_id, {})
                    .then(({data}) => {
                        this.before = data.before
                        this.after = data.after
                    })
            },
        },
        created: function () {
            if (this.role_supervisor != 0) {
                this.salon_id = this.role_supervisor
                this.salonCheck()
            }
        },
    }
</script>

<style lang="less">
    @import "../../less/_boot";

    .tabs-stocks {
        .nav-tabs {
            border-width: 0;
            > li {
                > a {
                    font-size: 15px;
                    line-height: 81px;
                    color: #727378;
                    padding: 0px 40px;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                    cursor: pointer;
                    border-width: 3px 0 0 !important;
                    border-radius: 0;
                }
            }
        }
        .stocks-head {
            background-color: #fff;
            .form-group {
                padding: 15px;
                width: 366px;
                margin: 0px;
                h2 {
                    width: 217px;
                    height: 25px;
                    font-size: 22px;
                    font-weight: 500;
                    text-align: left;
                    margin-top: 0;
                }
                h3 {
                    width: 186px;
                    height: 14px;
                    font-size: 18px;
                    line-height: 0.78;
                    letter-spacing: 0px;
                    color: #555555;
                }
            }
        }
        .panel-default {
            background-color: #fff;
            padding: 20px;
        }
        .form-stock {
            textarea {
                width: 639px;
                height: 198px;
                border-radius: 2px;
                background-color: #ffffff;
                border: solid 1px #cccccc;
            }
            .btn-primary {
                margin-top: 20px;
            }
        }

        textarea {
            display: none;
        }
        textarea.active {
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// TabsStocks.vue?1f44921e